module.exports = __webpack_public_path__ + "static/img/phoneappletcode.5063ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/phoneappletcode.png
// module id = 15
// module chunks = 1 2 3 4 5 6 7 8 9